<!--
 * @Author: BeanDou
 * @LastEditors: BeanDou
 * @Date: 2020-06-17 15:55:04
 * @LastEditTime: 2020-06-18 16:36:46
 * @Description: File description
-->
<template>
  <div class="loginView">
    <!-- <appHeaderLogin></appHeaderLogin> -->
    <div class="mainWrapper">
      <div class="login-panel-left">
        <div class="login-panel-left-img"></div>
      </div>
      <div class="loginTabWrapper">
        <el-tabs v-model="currentTab">
          <el-tab-pane label="账号密码登录" name="0">
            <!-- <span class="titleSlot" slot="title">账号密码登录
              <i class="underscore"></i>
            </span> -->
            <accountTab :last-user="lastLoggedUser" :checkedAgreement="checkedAgreement"></accountTab>
          </el-tab-pane>
          <el-tab-pane label="验证码登录" name="1">
            <!-- <span class="titleSlot" slot="title">验证码登录
              <i class="underscore"></i>
            </span> -->
            <smsTab :last-user="lastLoggedUser" :checkedAgreement="checkedAgreement"></smsTab>
          </el-tab-pane>
        </el-tabs>
        <!-- 用户协议和隐私策略 -->
        <agreement @agreement="handlerAgree"></agreement>
      </div>
    </div>
  </div>
</template>

<script>
import accountTab from './liveAccountTab'
import authUtils from '@/services/utils'
import smsTab from './smsTab'
import { LIVE_URL } from '@/config'
import agreement from './agreement.vue'
export default {
  name: 'stuLogin',
  data () {
    return {
      currentTab: 0,
      lastLoggedUser: {},
      checkedAgreement: false
    }
  },
  components: {
    accountTab,
    smsTab,
    agreement
  },
  created () {
    authUtils.removeFromUrl()
    let lastLoggedUser = authUtils.getLastLoggedUser()
    if (lastLoggedUser) {
      this.lastLoggedUser = lastLoggedUser
    }
  },
  mounted () {
    // 解决由于未登录直接跳转至子页面导致的骨架屏不消失问题
    // Vue.skeleton.hide()
  },
  methods: {
    linkLiveLogin () {
      window.location.href = LIVE_URL
    },
    handlerAgree (type) {
      console.log('[live account] handlerAgree :: type = ', type)
      this.checkedAgreement = type
    }
  }
}
</script>

<style lang="scss" scoped>
  .loginView {
    .mainWrapper {
      position: absolute;
      left: 50%;
      top: 50%;
      transform: translate(-50%, -50%);
      display: flex;
      width: 1000px;
      padding: 15px 0 59px 134px;
      background: #fff;
      z-index: 1;
      @include panel-rounded;
      @include panel-blur;
      .loginTabWrapper {
        height: 404px;
        padding: 0 0 0 112px ;
        background-color: #fff;
        /deep/ .el-tabs__nav-wrap {
          padding: 0 55px;
          .el-tabs__active-bar {
            width: 16px !important;
            height: 5px;
            left: 50px;
            background-color: #2D5BFF;
            border-radius: 3px;
          }
          .el-tabs__item {
            color: #8e9dae;
            font-size: 20px;
            font-weight: 500;
            &:last-of-type {
              margin-left: 8px;
            }
            &.is-active {
              color: #202428;
            }
          }
          &:after {
            display: none;
          }
        }
        /deep/ .el-tabs__content {
          margin-top: 55px;
        }
        /deep/ .el-tabs .el-tabs__content {
          overflow: visible;
        }
      }
      /deep/ .pl85 {
        // padding-left: 80px;
      }
    }
    .login-panel-left {
      position: relative;
      background: #fff;
      .login-panel-left-img {
        width: 304px;
        height: 402px;
        background: url(https://fe-cdn.mofaxiao.com/cactus-portal/static/img/bg-login-panel-left.png) no-repeat;
        background-size: cover;
      }
      &:before {
        content: 'Hello';
        position: absolute;
        top: -30px;
        left: -45px;
        font-size: 66px;
        font-family: PingFangSC-Semibold,PingFang SC;
        font-weight: 600;
        color: #2D5BFF;
        height: 66px;
        line-height: 66px;
      }
    }
  }
</style>
